import { t } from "@/i18n-js/instance";

export const TAB_DISCOVER = "discover";
export const TAB_MY_CONNECTIONS = "my_connections";

export const CONNECT_PANEL_SCROLL_CONTAINER_ID =
  "connect-panel-scroll-container";

export const TABS = [
  {
    value: TAB_DISCOVER,
    get label() {
      return t("header_v3.connect.tabs.discover.title");
    },
  },
  {
    value: TAB_MY_CONNECTIONS,
    get label() {
      return t("header_v3.connect.tabs.my_connections.title");
    },
  },
];
